<template>
  <div>
    <VSectionBar
      id="user-voices"
      message="保護者の方からの声"
    />
    <v-sheet
      class="main--text"
    >
      <v-container
        fluid
      >
        <v-row
          justify=center
        >
          <v-col
            cols=12
            sm=10
            md=8
          >
            <v-container
              fluid
            >
              <v-row
                jusitfy=start
                align=center
              >
                <v-col
                  cols=2
                  sm=1
                >
                  <v-avatar>
                    <v-icon
                      :x-large="$vuetify.breakpoint.mdAndUp"
                      :large="$vuetify.breakpoint.smAndDown"
                      >mdi-account</v-icon>
                  </v-avatar>
                </v-col>
                <v-col
                  cols=9
                  sm=9
                  class="balloon-left"
                >
                  <p>息子はマインクラフトにとても興味があり、本人のやる気が出て、継続して勉強ができます！！</p>
                </v-col>
              </v-row>
              <v-row
                justify=end
                align=center
              >
                <v-col
                  cols=9
                  sm=9
                  class="balloon-right">
                  <p>今まではゲームばっかりしていて全く勉強できない子供でしたが、<br>マインクラフトを使ってのプログラミングには熱中しています！</p>
                </v-col>
                <v-col
                  cols=2
                  sm=1
                >
                  <v-avatar>
                    <v-icon
                      :x-large="$vuetify.breakpoint.mdAndUp"
                      :large="$vuetify.breakpoint.smAndDown"
                    >mdi-account</v-icon>
                  </v-avatar>
                </v-col>
              </v-row>
              <v-row
                jusitfy=start
                align=center
              >
                <v-col
                  cols=2
                  sm=1
                >
                  <v-avatar>
                    <v-icon
                      :x-large="$vuetify.breakpoint.mdAndUp"
                      :large="$vuetify.breakpoint.smAndDown"
                    >mdi-account</v-icon>
                  </v-avatar>
                </v-col>
                <v-col
                  cols=9
                  sm=9
                  class="balloon-left"
                >
                  <p>ゲームを通じて将来に役立つITスキルを身につけられるのは<br>こどもの将来を考えるととても安心できる。</p>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </div>
</template>

<script>
import VSectionBar from '@/components/molecules/VSectionBar.vue'

export default {
  name: 'VUsersVoice',
  components: {
    VSectionBar,
  }
}
</script>

<style scoped>

.balloon-left {
  position: relative;
  display: inline-block;
  margin: 1.5rem 0 1.5rem 15px;
  padding: 7px 10px;
  min-width: 120px;
  max-width: 100%;
  color: #555;
  font-size: 16px;
  background: #FFF;
  border: solid 3px #555;
  box-sizing: border-box;
  border-radius: 10px;
}

.balloon-left:before {
  content: "";
  position: absolute;
  top: 50%;
  left: -24px;
  margin-top: -12px;
  border: 12px solid transparent;
  border-right: 12px solid #FFF;
  z-index: 2;
}

.balloon-left:after {
  content: "";
  position: absolute;
  top: 50%;
  left: -30px;
  margin-top: -14px;
  border: 14px solid transparent;
  border-right: 14px solid #555;
  z-index: 1;
}

.balloon-left p {
  margin: 0;
  padding: 0;
}

.balloon-right {
  position: relative;
  display: inline-block;
  margin: 1.5rem 15px 1.5rem 0;
  padding: 7px 10px;
  min-width: 120px;
  max-width: 100%;
  color: #555;
  font-size: 16px;
  background: #FFF;
  border: solid 3px #555;
  box-sizing: border-box;
  border-radius: 10px;
}

.balloon-right:before {
  content: "";
  position: absolute;
  top: 50%;
  right: -24px;
  margin-top: -12px;
  border: 12px solid transparent;
  border-left: 12px solid #FFF;
  z-index: 2;
}

.balloon-right:after {
  content: "";
  position: absolute;
  top: 50%;
  right: -30px;
  margin-top: -14px;
  border: 14px solid transparent;
  border-left: 14px solid #555;
  z-index: 1;
}

.balloon-right p {
  margin: 0;
  padding: 0;
}

</style>